module.exports = __webpack_public_path__ + "img/th@2x.3f1bd08f.png";